import { createSlice } from "@reduxjs/toolkit";

interface ResetState {
	isResetTriggered: boolean;
	resetTimestamp: number;
}

const initialState: ResetState = {
	isResetTriggered: false,
	resetTimestamp: 0,
};

const resetSlice = createSlice({
	name: "reset",
	initialState,
	reducers: {
		triggerReset(state) {
			state.isResetTriggered = true;
			state.resetTimestamp = Date.now();
		},
		clearReset(state) {
			state.isResetTriggered = false;
		},
		resetAll() {
			return initialState;
		},
	},
});

export const { triggerReset, clearReset, resetAll } = resetSlice.actions;
export default resetSlice.reducer;
